'use client'

import { FilterCollapse } from './filter/FilterCollapse'
import { SizeCollapse } from './filter/SizeCollapse'
import SliderControlled from './filter/SliderControlled'
import { DopCollapse } from '@/components/template/DopCollapse'
import classNames from 'classnames'
import type { CommonProps } from '@/@types/common'
// import { ColorCollapse } from './filter/ColorCollaps'
import { SectionCollapse } from './filter/SectionCollapse'
import { normalizeSizes } from './filter/utils/size'
import { ColorLikeSize } from './filter/CollorLikeSize'

import { TbMoodEmpty } from 'react-icons/tb'
import { mapToSectionOptions } from './filter/utils/normalizegender'

const avalableOptions = [
    { value: 'true', label: 'В наличии' },
    { value: 'false', label: 'Под заказ' },
]
interface SidebarProps extends CommonProps {
    initialRange: {
        minPrice?: number
        maxPrice?: number
        sections?: string[]
        colors?: string[]
        sizes?: string[]
        genders?: string[]
        seasons?: string[]
    }
    categoryId: string
}
export const SideBarCategory = (props: SidebarProps) => {
    const { className, initialRange, categoryId } = props

    console.log(initialRange, 'почему цвет видно')
    if (!categoryId || !initialRange) {
        return (
            <div className="py-16 px-4 flex flex-col items-center justify-center text-gray-500">
                <div className="flex justify-center">
                    <TbMoodEmpty size={38} />
                </div>

                <p className="text-lg  mb-2 text-center">
                    Проводятся технические работы. Приносим свои извинения
                </p>
                <p className="text-sm">Попробуйте зайти позднее</p>
            </div>
        )
    }

    const genderOptions = mapToSectionOptions(initialRange.genders)
    const seasonOptions = mapToSectionOptions(initialRange.seasons)
    const sectionsOption = mapToSectionOptions(initialRange.sections)
    const normalizedSizes = normalizeSizes(initialRange.sizes)
    return (
        <div className={classNames('max-w-xs w-full', className)}>
            <div className="hidden lg:block text-3xl leading-tight font-bold text-gray-900">
                Фильтры
            </div>
            <div className="py-4 lg:py-[86px] flex flex-col gap-10">
                {initialRange.maxPrice != null && (
                    <DopCollapse title="Цена" defaultOpen>
                        <SliderControlled
                            initialRange={{
                                minPrice: initialRange.minPrice ?? 0,
                                maxPrice: initialRange.maxPrice ?? 0,
                            }}
                            categoryId={categoryId}
                        />
                    </DopCollapse>
                )}

                                {(initialRange.sections?.length ??0) > 0 && (
                    <SectionCollapse
                        title="Раздел"
                        options={sectionsOption}
                        defaultSelected={['куртки']}
                        paramName="section"
                        storeKey="sections"
                    />
                )}
                {initialRange.colors && (
                    <ColorLikeSize colorOptions={initialRange.colors} />
                )}

                <SectionCollapse
                    title="В наличии"
                    options={avalableOptions}
                    defaultSelected={['В наличии']}
                    paramName="available"
                    storeKey={'available'}
                />
                {(initialRange.seasons?.length ?? 0) > 0 && (
                    <SectionCollapse
                        title="Сезон"
                        options={seasonOptions}
                        defaultSelected={['зима']}
                        paramName="season"
                        storeKey="seasons"
                    />
                )}

                {(initialRange.genders?.length ??0) > 0 && (
                    <SectionCollapse
                        title="Пол"
                        options={genderOptions}
                        defaultSelected={['мужской']}
                        paramName="gender"
                        storeKey="genders"
                    />
                )}
            </div>
        </div>
    )
}
